<template>
  <div class="lp-rotate-flip">
    <div class="lp-rotate-flip__group">
      <button
          v-tooltip="'Rotate left'"
          :disabled="disabled"
          type="button"
          class="lp-rotate-flip__btn"
          aria-label="Rotate left"
          @click="$emit('rotate', 'left')">
        <icon name="rotateleft"/>
      </button>
      <button
          v-tooltip="'Rotate right'"
          :disabled="disabled"
          type="button"
          class="lp-rotate-flip__btn"
          aria-label="Rotate right"
          @click="$emit('rotate', 'right')">
        <icon name="rotateright"/>
      </button>
    </div>
    <div class="lp-rotate-flip__group">
      <button
          v-tooltip="'Flip vertical'"
          :class="{ 'is-active': flippedV }"
          :disabled="disabled"
          type="button"
          class="lp-rotate-flip__btn"
          aria-label="Flip vertical"
          @click="$emit('flip', 'vertical')">
        <icon name="flipvertical"/>
      </button>
      <button
          v-tooltip="'Flip horizontal'"
          :class="{ 'is-active': flippedH }"
          :disabled="disabled"
          type="button"
          class="lp-rotate-flip__btn"
          aria-label="Flip horizontal"
          @click="$emit('flip', 'horizontal')">
        <icon name="fliphorizontal"/>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name:  'RotateFlipControls',
  props: {
    flippedH: { type: Boolean, default: false },
    flippedV: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-rotate-flip {
  display: flex;
  gap: 8px;
}

.lp-rotate-flip__group {
  display: flex;
  flex: 1 1 0;
  gap: 2px;
  min-width: 0;
  padding: 3px;
  border-radius: 10px;
  background: $lp-fill;
}

.lp-rotate-flip__btn {
  display: flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  height: 26px;
  min-width: 0;
  padding: 0 6px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #3d4350;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: rgba($white, 0.7);
  }

  &.is-active {
    background: $white;
    color: #0b57c2;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1), 0 0 0 1px #e7e9ed;
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  ::v-deep .icon {
    min-width: 0;
    min-height: 0;
    color: inherit;
  }

  ::v-deep svg {
    display: block;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
}
</style>
